"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[347],{

/***/ 60768:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
}), 'LocalPhone');
exports.Z = _default;

/***/ }),

/***/ 26307:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"
}), 'Send');
exports.Z = _default;

/***/ }),

/***/ 84007:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var React = _interopRequireWildcard(__webpack_require__(67294));
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65A9.969 9.969 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96A7.95 7.95 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8z"
}), 'WhatsApp');
exports.Z = _default;

/***/ }),

/***/ 68915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ agent_profile; }
});

// UNUSED EXPORTS: getStaticProps

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(83618);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./lang/en.json
var lang_en = __webpack_require__(64798);
// EXTERNAL MODULE: ./lang/es.json
var lang_es = __webpack_require__(89890);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./shared/components/buy-sell-filter/index.tsx + 1 modules
var buy_sell_filter = __webpack_require__(97814);
// EXTERNAL MODULE: ./shared/components/header-title-profile/index.tsx
var header_title_profile = __webpack_require__(50408);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./shared/components/messages-result/index.tsx
var messages_result = __webpack_require__(52659);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./shared/components/contact-agent-dialog/index.tsx
var contact_agent_dialog = __webpack_require__(21689);
// EXTERNAL MODULE: ./shared/components/ws-contact-group/index.tsx + 3 modules
var ws_contact_group = __webpack_require__(99225);
// EXTERNAL MODULE: ./custom-hooks/data-layer-event.hook.ts
var data_layer_event_hook = __webpack_require__(65198);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components-pages/profiles/agent-profile/components/contact-section/index.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








function ContactSection(props) {
  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useDataLayerEvent = (0,data_layer_event_hook/* default */.Z)(),
      event = _useDataLayerEvent.event;

  var profileInfo = props.profileInfo;
  var hiddenContact = [9 // wilton
  ].includes(profileInfo.id);

  var handleClose = function handleClose() {
    setOpen(!open);
  };

  var ClickWhatsAppAgent = function ClickWhatsAppAgent() {
    event({
      event_name: "whatsapp_contact_agent",
      body: {
        id_agente: profileInfo.id
      }
    });
  };

  var ClickPhoneAgent = function ClickPhoneAgent() {
    event({
      event_name: "phone_contact_agent",
      body: {
        id_agente: profileInfo.id
      }
    });
  };

  var ClickEmailAgent = function ClickEmailAgent() {
    event({
      event_name: "email_contact_agent",
      body: {
        id_agente: profileInfo.id
      }
    });
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    md: 4,
    xs: 12
  }, !hiddenContact && (0,emotion_react_browser_esm/* jsx */.tZ)(ws_contact_group/* default */.Z, {
    phone: profileInfo.mobile || profileInfo.phone || profileInfo.phone2,
    whatsapp: profileInfo.mobile || profileInfo.phone || profileInfo.phone2,
    email: profileInfo.email,
    wsClick: function wsClick() {
      return ClickWhatsAppAgent();
    },
    phoneClick: function phoneClick() {
      return ClickPhoneAgent();
    },
    emailClick: function emailClick() {
      return handleClose();
    }
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(contact_agent_dialog/* default */.Z, {
    open: open,
    onClose: handleClose,
    entity_info: profileInfo,
    isAgency: false,
    classNameModalButton: "enviar-formulario-contacto-agente",
    customClass: "agent",
    onCallBackSubmitEnd: function onCallBackSubmitEnd() {
      ClickEmailAgent();
    }
  }));
}

/* harmony default export */ var contact_section = (ContactSection);

var ContactInfoContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16kh21q5"
} : 0)( true ? {
  name: "rccfl2",
  styles: "justify-self:flex-end;margin-left:auto;@media screen and (max-width: 991px){margin-right:0;}@media screen and (max-width: 767px){margin-right:auto;}"
} : 0);

var ContactInfoText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e16kh21q4"
} : 0)( true ? {
  name: "12qngrf",
  styles: "font-size:1rem;font-weight:600;color:#262b30;border-top:1px solid #CBCBCB;border-bottom:1px solid #CBCBCB;padding:15px 20px;margin-bottom:20px;text-align:center"
} : 0);

var ContainerButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16kh21q3"
} : 0)( true ? {
  name: "13keaft",
  styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;a{margin:5px 0px;}"
} : 0);

var ContentInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e16kh21q2"
} : 0)( true ? {
  name: "tkmsje",
  styles: "list-style:none;@media screen and (max-width: 767px){margin-bottom:20px;}&.--Contacts{margin-bottom:20px;& span{width:90%;margin:auto;display:flex;& svg{padding-right:5px;}a{width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}}}"
} : 0);

var Info = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e16kh21q1"
} : 0)( true ? {
  name: "v0ghfj",
  styles: "display:block;font-size:1.063rem;font-weight:500;color:var(--color-brand-blue-main);vertical-align:middle;&.--description{white-space:nowrap;span{font-family:\"Arial\";vertical-align:middle;color:var(--color-brand-grey-secondary);}svg{color:var(--color-brand-grey-secondary);}&.--contact{margin-top:10px;}}"
} : 0);

var AgencyImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16kh21q0"
} : 0)( true ? {
  name: "a938x5",
  styles: "img{max-width:191px;width:100%;}@media screen and (max-width: 767px){width:158px;text-align:center;margin:auto;}"
} : 0);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
;// CONCATENATED MODULE: ./shared/components-pages/profiles/agent-profile/components/profile-picture-section/index.tsx


function profile_picture_section_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






function ProfilePictureSection(props) {
  var profileInfo = props.profileInfo;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(ThumbnailGrid, {
    item: true,
    xl: 3,
    lg: 4,
    xs: 12
  }, profileInfo.picture && (0,emotion_react_browser_esm/* jsx */.tZ)(Thumbnail, null, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
    src: profileInfo.picture,
    alt: "profile-picture",
    width: 263,
    height: 263
  })), profileInfo.picture == null && (0,emotion_react_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
    variant: "circular",
    width: 263,
    height: 263
  }));
}

/* harmony default export */ var profile_picture_section = (ProfilePictureSection);

var ThumbnailGrid = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Grid/* default */.ZP,  true ? {
  target: "e63cdby1"
} : 0)( true ? {
  name: "ccb0bj",
  styles: "& span{margin:0 auto;}"
} : 0);

var Thumbnail = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e63cdby0"
} : 0)( true ? {
  name: "1s8p1rm",
  styles: "display:flex;img{width:263px;height:263px;border-radius:50%;margin:auto;background:grey;object-fit:cover;}@media screen and (max-width: 991px){}@media screen and (max-width: 767px){}"
} : 0);
// EXTERNAL MODULE: ./shared/components-pages/proyectos/PropertiesSlider.tsx
var PropertiesSlider = __webpack_require__(42979);
// EXTERNAL MODULE: ./shared/components/slider-collection-property/index.tsx
var slider_collection_property = __webpack_require__(2098);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
;// CONCATENATED MODULE: ./shared/components-pages/profiles/agent-profile/components/sliders-section/index.tsx



function sliders_section_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function SliderSection(props) {
  var profileInfo = props.profileInfo,
      IsUserCollection = props.IsUserCollection;
  var translationProperties = (0,next_intl_cjs_production_min.useTranslations)("agentProfile.properties");
  var translationCollection = (0,next_intl_cjs_production_min.useTranslations)("agentProfile.collection");
  var collectionTitle = translationCollection("title") || "";

  var _collectionTitle$spli = collectionTitle.split(" "),
      _collectionTitle$spli2 = (0,toArray/* default */.Z)(_collectionTitle$spli),
      title = _collectionTitle$spli2[0],
      rest = _collectionTitle$spli2.slice(1);

  var _useRouter = (0,next_router.useRouter)(),
      asPath = _useRouter.asPath;

  var isCollection = asPath.includes(pages_path/* CPagesPath.es.collection */.K.es.collection);
  console.log(profileInfo.is_collection_agent);
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentSliderProperty, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PropertiesSlider/* default */.Z, {
    subtitle: "",
    title: translationProperties("title"),
    refRequest: "property-list-normal-query",
    detailPath: pages_path/* CPagesPath.es.property_detail */.K.es.property_detail,
    withoutResultsComponent: (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
      style: {
        marginTop: 20
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
      href: pages_path/* CPagesPath.es.properties */.K.es.properties + "?referer=".concat(profileInfo.id)
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      component: "a"
    }, "Ver mas propiedades"))),
    filters: {
      agent: profileInfo.id
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.properties */.K.es.properties + "?referer=".concat(profileInfo.id)
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a"
  }, translationProperties("seeMore"))))), !!profileInfo.is_collection_agent && (0,emotion_react_browser_esm/* jsx */.tZ)(ContentSliderPropertyCollection, null, (0,emotion_react_browser_esm/* jsx */.tZ)(slider_collection_property/* default */.Z, {
    title: title,
    subTitle: rest.join(" "),
    filter: {
      agent: profileInfo.id
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.collection_properties */.K.es.collection_properties + "?referer=".concat(profileInfo.id)
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a"
  }, translationCollection("seeMore"))))));
}

/* harmony default export */ var sliders_section = (SliderSection);

var ContentSliderProperty = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2l7ztf1"
} : 0)( true ? {
  name: "160bhsu",
  styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;width:95%;margin:auto auto 50px;& section{margin-bottom:0px!important;}"
} : 0);

var ContentSliderPropertyCollection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e2l7ztf0"
} : 0)( true ? {
  name: "7ow2dw",
  styles: "margin:auto;width:90%;text-align:center;margin:80px auto;a{margin-top:10px;.collection__card__description{color:var(--color-brand-blue-main);span{color:var(--color-brand-blue-main);}}}"
} : 0);
;// CONCATENATED MODULE: ./shared/components-pages/profiles/agent-profile/components/user-info-section/index.tsx


function user_info_section_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






function UserInfoSection(props) {
  var profileInfo = props.profileInfo;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xl: 5,
    lg: 5,
    md: 7,
    sm: 6,
    xs: 12
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentDetail, null, (0,emotion_react_browser_esm/* jsx */.tZ)(LabelNameUser, {
    className: "nombre-agente"
  }, profileInfo.name), (0,emotion_react_browser_esm/* jsx */.tZ)(user_info_section_ContentInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentInfoItem, null, profileInfo.agency_picture && (0,emotion_react_browser_esm/* jsx */.tZ)(user_info_section_AgencyImage, null, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
    src: profileInfo.agency_picture,
    alt: profileInfo.agency_name,
    className: "nombre-agencia"
  })), profileInfo.agency_picture == null && (0,emotion_react_browser_esm/* jsx */.tZ)(Skeleton/* default */.Z, {
    variant: "rounded",
    width: 200,
    height: 50
  })))));
}

/* harmony default export */ var user_info_section = (UserInfoSection);

var ContentDetail = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e276m05"
} : 0)( true ? {
  name: "103s3r8",
  styles: "height:100%;margin-top:15px;@media screen and (max-width: 991px){}@media screen and (max-width: 867px){width:100%;margin:0 auto 20px;display:flex;flex-direction:column;align-items:center;}"
} : 0);

var LabelNameUser = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e276m04"
} : 0)( true ? {
  name: "x6n1tc",
  styles: "font-size:2.188rem;font-weight:700;text-align:left;color:var(--color-brand-blue-main);margin-bottom:10px;span{font - weight:300;}@media screen and (max-width: 767px){text - align:center;margin-bottom:20px;font-size:1.788rem;}"
} : 0);

var user_info_section_ContentInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e276m03"
} : 0)( true ? {
  name: "y4pz0b",
  styles: "list-style:none;@media screen and (max-width: 767px){margin - bottom:20px;}&.--Contacts{margin - bottom:20px;& span{width:70%;margin:auto;display:flex;& svg{padding - right:5px;}}}"
} : 0);

var ContentInfoItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e276m02"
} : 0)( true ? {
  name: "avpsk8",
  styles: "margin-bottom:15px"
} : 0);

var user_info_section_Info = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e276m01"
} : 0)( true ? {
  name: "1loxt06",
  styles: "display:block;font-size:1.063rem;font-weight:500;color:var(--color-brand-blue-main);&.--description{color:var(--color-brand-grey-secondary);white-space:nowrap;&.--contact{margin - top:10px;}}"
} : 0);

var user_info_section_AgencyImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e276m00"
} : 0)( true ? {
  name: "13o6fwg",
  styles: "img{width:20rem;}@media screen and (max-width: 767px){display:flex;justify-content:center;width:14rem;text-align:center;margin:auto;}"
} : 0);
// EXTERNAL MODULE: ./shared/components/layout/index.tsx + 40 modules
var layout = __webpack_require__(85393);
// EXTERNAL MODULE: ./shared/models/functions/removeparams.ts
var removeparams = __webpack_require__(57626);
;// CONCATENATED MODULE: ./shared/components-pages/profiles/agent-profile/index.tsx





function agent_profile_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




















// Move adapter outside component for better performance
var adapterAgent = function adapterAgent(data) {
  var _data$data$id, _data$data, _data$data$picture, _data$data2, _data$data$user_type_, _data$data3, _data$data$name, _data$data4, _data$data$email, _data$data5, _data$data$mobile, _data$data6, _data$data$phone, _data$data7, _data$data$phone2, _data$data8, _data$data$agency_id, _data$data9, _data$data$agency_nam, _data$data10, _data$data$agency_pic, _data$data11, _data$data$social_net, _data$data12, _data$data$address, _data$data13, _data$data$rating, _data$data14, _data$data$is_collect, _data$data15;

  return {
    id: (_data$data$id = (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.id) !== null && _data$data$id !== void 0 ? _data$data$id : null,
    picture: (_data$data$picture = (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.picture) !== null && _data$data$picture !== void 0 ? _data$data$picture : null,
    user_type_name: (_data$data$user_type_ = (_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.user_type_name) !== null && _data$data$user_type_ !== void 0 ? _data$data$user_type_ : "-",
    name: (_data$data$name = (_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.name) !== null && _data$data$name !== void 0 ? _data$data$name : "-",
    email: (_data$data$email = (_data$data5 = data.data) === null || _data$data5 === void 0 ? void 0 : _data$data5.email) !== null && _data$data$email !== void 0 ? _data$data$email : "-",
    mobile: (_data$data$mobile = (_data$data6 = data.data) === null || _data$data6 === void 0 ? void 0 : _data$data6.mobile) !== null && _data$data$mobile !== void 0 ? _data$data$mobile : "-",
    phone: (_data$data$phone = (_data$data7 = data.data) === null || _data$data7 === void 0 ? void 0 : _data$data7.phone) !== null && _data$data$phone !== void 0 ? _data$data$phone : "-",
    phone2: (_data$data$phone2 = (_data$data8 = data.data) === null || _data$data8 === void 0 ? void 0 : _data$data8.phone2) !== null && _data$data$phone2 !== void 0 ? _data$data$phone2 : "-",
    agency_id: (_data$data$agency_id = (_data$data9 = data.data) === null || _data$data9 === void 0 ? void 0 : _data$data9.agency_id) !== null && _data$data$agency_id !== void 0 ? _data$data$agency_id : null,
    agency_name: (_data$data$agency_nam = (_data$data10 = data.data) === null || _data$data10 === void 0 ? void 0 : _data$data10.agency_name) !== null && _data$data$agency_nam !== void 0 ? _data$data$agency_nam : "-",
    agency_picture: (_data$data$agency_pic = (_data$data11 = data.data) === null || _data$data11 === void 0 ? void 0 : _data$data11.agency_picture) !== null && _data$data$agency_pic !== void 0 ? _data$data$agency_pic : null,
    social_networks: (_data$data$social_net = (_data$data12 = data.data) === null || _data$data12 === void 0 ? void 0 : _data$data12.social_networks) !== null && _data$data$social_net !== void 0 ? _data$data$social_net : null,
    address: (_data$data$address = (_data$data13 = data.data) === null || _data$data13 === void 0 ? void 0 : _data$data13.address) !== null && _data$data$address !== void 0 ? _data$data$address : "-",
    rating: (_data$data$rating = (_data$data14 = data.data) === null || _data$data14 === void 0 ? void 0 : _data$data14.rating) !== null && _data$data$rating !== void 0 ? _data$data$rating : 0,
    is_collection_agent: (_data$data$is_collect = (_data$data15 = data.data) === null || _data$data15 === void 0 ? void 0 : _data$data15.is_collection_agent) !== null && _data$data$is_collect !== void 0 ? _data$data$is_collect : 0
  };
};

function getStaticProps(_x) {
  return _getStaticProps.apply(this, arguments);
}

function _getStaticProps() {
  _getStaticProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var locale;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            locale = _ref.locale;
            return _context.abrupt("return", {
              props: {
                messages: locale === "es" ? es : en
              }
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getStaticProps.apply(this, arguments);
}

function AgentProfileContain(props) {
  var id = props.id,
      IsUserCollection = props.IsUserCollection,
      data = props.data;
  var router = (0,next_router.useRouter)();
  var translation = (0,next_intl_cjs_production_min.useTranslations)("agentProfile");
  var isCollection = router.asPath.includes(pages_path/* CPagesPath.es.collection */.K.es.collection);
  var agencyTitle = translation("title") || "";

  var _agencyTitle$split = agencyTitle.split(" "),
      _agencyTitle$split2 = (0,toArray/* default */.Z)(_agencyTitle$split),
      title = _agencyTitle$split2[0],
      rest = _agencyTitle$split2.slice(1); // Memoize adapted data and config


  var profileInfo = (0,react.useMemo)(function () {
    return adapterAgent(data);
  }, [data]);
  var config = (0,react.useMemo)(function () {
    return {
      profileInfo: profileInfo,
      IsUserCollection: IsUserCollection
    };
  }, [profileInfo, IsUserCollection]); // Memoize metadata

  var metaData = (0,react.useMemo)(function () {
    return {
      description: "Agente inmobiliario ".concat(profileInfo.name, " de RE/MAX Republica Dominicana ubicada"),
      keyWords: "Agente inmobiliario, Agente inmobiliario remax rd, Agente Remax, Remax agencia inmobiliaria, Agente Remax República Dominicana",
      url: "https://remaxrd.com" + router.asPath,
      type: "Agente RE/MAX",
      title: "Agente ".concat(profileInfo.name.toUpperCase(), "-RE/MAX Republica Dominicana")
    };
  }, [profileInfo.name, router.asPath]);
  (0,react.useEffect)(function () {
    var agentSlug = data.data.name.replaceAll(" ", "-").toLowerCase();
    var basePath = isCollection ? "/collection/agente/" : "/agente/";
    var url = "".concat(basePath).concat(agentSlug, "/").concat(id, "?referer=").concat(id); // router.replace(url, undefined, { shallow: true });
  }, [data.data.name, id, isCollection, router]);

  if (!data) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "...error"
    });
  }

  return (0,emotion_react_browser_esm/* jsx */.tZ)(layout/* default */.Z, {
    showFooter: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)((head_default()), null, (0,emotion_react_browser_esm/* jsx */.tZ)("title", null, metaData.title), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "description",
    content: metaData.description
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "keywords",
    content: metaData.keyWords
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:url",
    content: metaData.url
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:type",
    content: metaData.type
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:title",
    content: metaData.title
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:image",
    content: profileInfo.picture || ""
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("link", {
    rel: "canonical",
    href: (0,removeparams/* default */.Z)(metaData.url),
    key: "canonical"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Content, null, (0,emotion_react_browser_esm/* jsx */.tZ)(header_title_profile/* default */.Z, {
    label: rest.join(" "),
    title: title
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Card, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardContainer, {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    justifyItems: "center",
    spacing: 2,
    my: 2
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(profile_picture_section, config), (0,emotion_react_browser_esm/* jsx */.tZ)(user_info_section, config), (0,emotion_react_browser_esm/* jsx */.tZ)(contact_section, config))), (0,emotion_react_browser_esm/* jsx */.tZ)(FilterContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(buy_sell_filter/* default */.Z, {
    redirect: pages_path/* CPagesPath.es.properties */.K.es.properties
  }))), profileInfo.id && (0,emotion_react_browser_esm/* jsx */.tZ)(sliders_section, config))));
}

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e844mq83"
} : 0)( true ? {
  name: "w4qr9k",
  styles: "margin-top:100px;@media screen and (max-width: 767px){margin-top:60px;}"
} : 0);

var Card = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e844mq82"
} : 0)( true ? {
  name: "cw9uk6",
  styles: "padding-top:50px;padding-bottom:80px;background-color:#fff;@media screen and (max-width: 550px){padding-top:10px;}@media screen and (max-width: 767px){padding-bottom:50px;}"
} : 0);

var CardContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e844mq81"
} : 0)( true ? {
  name: "861p4a",
  styles: "display:flex;flex-wrap:wrap;border-bottom:1px solid #CBCBCB;padding-bottom:50px;@media screen and (max-width: 991px){justify-content:space-between;}@media screen and (max-width: 767px){flex-direction:column;&.container{padding-bottom:0;}}"
} : 0);

var FilterContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e844mq80"
} : 0)( true ? {
  name: "w4v749",
  styles: "width:100%;margin:auto;display:flex;margin-top:30px;& .content-body{background:#F7F6F4;.MuiInputBase-root{background:#F7F6F4;}}"
} : 0);

/* harmony default export */ var agent_profile = (AgentProfileContain);

/***/ }),

/***/ 50408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _titles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23814);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





function HeaderTitleProfile(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ContainerTitle, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_titles__WEBPACK_IMPORTED_MODULE_2__/* .TitleThickThin */ .U, {
    thickTitle: props.title || "",
    thinTitle: props.label
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (HeaderTitleProfile);

var ContainerTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("article",  true ? {
  target: "e1du7pdd0"
} : 0)( true ? {
  name: "1xx0702",
  styles: "height:100px;display:flex;justify-content:center;align-items:center;flex-direction:column;& h2{margin:0!important;}"
} : 0);

/***/ }),

/***/ 23814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ titles_TitleThickThin; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/titles/TitleThickThin.tsx



var _templateObject;

var _excluded = ["component", "align", "fw", "color", "fs", "mb"];




var TitleThickThin = function TitleThickThin(props) {
  var _props$component = props.component,
      component = _props$component === void 0 ? "h2" : _props$component,
      _props$align = props.align,
      align = _props$align === void 0 ? "center" : _props$align,
      _props$fw = props.fw,
      fw = _props$fw === void 0 ? 600 : _props$fw,
      _props$color = props.color,
      color = _props$color === void 0 ? "--color-text-black" : _props$color,
      _props$fs = props.fs,
      fs = _props$fs === void 0 ? "--fs-sub-title-large" : _props$fs,
      _props$mb = props.mb,
      mb = _props$mb === void 0 ? "60px" : _props$mb,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var Title = emotion_styled_browser_esm/* default */.Z[component](_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: auto;\n    font-family: var(--font-family);\n    font-size: 27.2px;\n    font-weight: ", ";\n    line-height: 21px;\n    letter-spacing: 0px;\n    color: var(", ");\n    text-align: ", ";\n    margin-bottom:", " !important;\n    & span{\n      font-weight: 400;\n      font-family: var(--font-family);\n    }\n  "])), fw, color, align, mb);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Title, {
    className: props.titleClass
  }, props.thickTitle, " ", (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: props.thickTitle
  }, props.thinTitle));
};

/* harmony default export */ var titles_TitleThickThin = (TitleThickThin);
;// CONCATENATED MODULE: ./shared/components/titles/index.tsx



/***/ })

}]);